/* src/app/shared/components/formly/formly-tariff-table/tariff-table.scss */
.remove-time-btn,
.expand-button {
  min-width: auto;
  --padding-start: 0.2rem;
  --padding-end: 0.2rem;
}
.tariff-input {
  flex: 1;
  min-width: 0;
  --padding-start: 0.3rem;
  --padding-end: 0.3rem;
}
.year-section {
  margin-bottom: 2rem;
  border: 1px solid var(--ion-color-medium-shade);
  padding: 1rem;
  border-radius: 8px;
}
.year-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.tariff-grid {
  width: 100%;
  border: 1px solid var(--ion-color-dark);
  margin: 1rem auto;
  max-width: 800px;
}
.price-items-container {
  background-color: var(--ion-color-light-shade);
  border-bottom: 1px solid var(--ion-color-dark);
  border-top: none;
  padding-bottom: 0.5rem;
  color: var(--ion-text-color);
}
.tariff-grid-header-row {
  background-color: transparent;
  border-bottom: none;
  padding: 0.5rem;
}
.tariff-price-row ion-col {
  padding: 0.5rem;
  border: 1px solid var(--ion-border-color);
  text-align: left;
  white-space: nowrap;
  background-color: transparent;
}
.tariff-input {
  text-align: right;
}
.input-unit {
  white-space: nowrap;
  font-size: 0.9em;
  color: var(--ion-color-medium-shade);
}
.quarter-row ion-col {
  padding: 0.5rem;
  border: 1px solid var(--ion-border-color);
  text-align: left;
  white-space: nowrap;
}
.quarter-label-col {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  white-space: normal;
  word-break: break-word;
}
.expand-button {
  height: auto;
  font-size: 1.2em;
}
.tariff-section {
  padding-left: 10%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.time-range-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.time-range-row .time-input {
  min-width: 90px;
  max-width: 120px;
  flex: 1 1 auto;
  --padding-start: 0.3rem;
  --padding-end: 0.3rem;
}
.time-range-row .time-separator {
  white-space: nowrap;
}
.remove-time-btn {
  margin-left: 0.25rem;
}
.add-time-btn {
  text-wrap: auto;
  display: inline-block;
  padding: 2%;
  margin-top: 0.5rem;
}
.year-actions {
  margin-top: 1.5rem;
}
.year-actions ion-toolbar {
  --background: transparent;
  --border-width: 0;
  padding: 0;
}
.year-actions ion-buttons {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .year-section {
    padding: 0.5rem;
  }
  .tariff-grid {
    margin: 0.5rem auto;
  }
  .tariff-input {
    font-size: 0.9rem;
  }
  .tariff-price-row {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
  .tariff-price-row ion-col {
    width: auto;
    text-align: left;
    white-space: nowrap;
    padding: 0.25rem;
  }
  .tariff-price-row ion-col:first-child {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-grow: 1;
  }
  .tariff-price-row .input-unit {
    margin-top: 0;
    margin-bottom: 0;
    flex-shrink: 0;
  }
  .input-unit {
    font-size: 0.8rem;
  }
  .quarter-label-col {
    font-size: 0.95rem;
  }
  .expand-button {
    font-size: 1rem;
  }
  .quarter-row ion-col {
    font-size: 0.85rem;
  }
  .time-range-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .time-range-row .time-input {
    width: 100%;
    max-width: none;
    text-align: left;
  }
  .time-range-row .time-separator {
    margin-left: 0;
  }
  .time-range-row .remove-time-btn {
    margin-left: 0;
    margin-top: 0.5rem;
  }
  .year-actions ion-buttons {
    justify-content: space-between;
  }
}
/*# sourceMappingURL=tariff-table.css.map */
